import APIS from '../../pages/lesson/detail/components/apis'
import { axios as $http, router } from 'cm'

// 判断是否登录
export function isLogin(backURL) {
  if (+window.baseInfo.user_id === 0) {
    window.toast('请先注册登录，页面即将跳转...', 3000)

    setTimeout(() => {
      let _href = window.$platform.isYixinliApp
        ? 'yixinli://open_user_login'
        : `${APIS.login}?next=${encodeURIComponent(
            backURL || window.location.href
          )}`

      // window.location.href = _href
      router.openWebView(_href)
    }, 3000)

    return false
  } else {
    return true
  }
}

// 获取json配置
export function getConfigureByCode(configureCode) {
  return $http.get({
    url: `https://yiapp.xinli001.com/commonConfigure/getConfigureByCode?configureCode=${configureCode}`,
    notEnv: true // 不使用环境参数
  })
}



// WEBPACK FOOTER //
// ./src/page-resource/lesson/utils.js